import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import useHttp from "hooks/use-http";
import { getUsersRequest } from "api/requests";
import { useCallback, useEffect, useState } from "react";
import LoadingCM from "components/shared/Loading";
import GenarateHeadCell from "helper/generate-head-cell";
import PaginationCM from "components/shared/Pagination";
import { PAGINATION_LIMIT } from "constants";

const headCells = GenarateHeadCell("users");
let initialPage = 1;

export default function Users() {
  const navigate = useNavigate();
  const [users, setUsers] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(initialPage);

  const handelSearch = (e) => getUsers(e);

  /////////////get users/////////////
  const getUsers = useCallback(
    async (search) => {
      const res = await request({
        url: getUsersRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search,
          type: "user",
        },
      });
      if (res.count < 1) {
        return setUsers({
          count: res.count,
          data: [{ content: "هیچ کاربری یافت نشد" }],
        });
      }

      if (res) {
        let transformedData = res.data.map((items) => ({
          id: items.id,
          full_name: items.full_name,
          phone_number: items.phone_number,
        }));

        setUsers({ data: transformedData, count: res.count });
      }
    },
    [page, request]
  );

  useEffect(() => {
    getUsers();
  }, [page, getUsers]);

  return (
    <DrawerCM title="کاربران عادی" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <Grid item xs={12} my={2}>
            <TableCM
              title="جدول کاربران عادی"
              rows={users.data}
              headCells={headCells}
              click={(userId) => navigate("/users/" + userId)}
              page={page}
            />
          </Grid>
          <PaginationCM
            handleChange={(e, val) => {
              initialPage = val;
              setPage(val);
            }}
            page={page}
            count={users.count}
          />
        </Grid>
      )}
    </DrawerCM>
  );
}
